module.exports = __webpack_public_path__ + "static/media/sangue do meu sangue.49f82aca.JPG";